import { render } from "./CustomizationShareEmailDialog.vue?vue&type=template&id=619caedb"
import script from "./CustomizationShareEmailDialog.vue?vue&type=script&lang=js"
export * from "./CustomizationShareEmailDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__